export default __webpack_public_path__ + "static/media/megabonplan.780f0e46.png";